import React from 'react';
import {
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Text,
	TextAlignment,
	ThemeProvider,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import { PortalContext } from '../context/PortalContext';
import { useTrackingManager } from '../tracking/useTrackingManager';

export const useErrorAlert = () => {
	const { layerManager } = React.useContext(PortalContext);
	const trackingManager = useTrackingManager();

	const showAlert = () => {
		trackingManager.trackClubVWErrorMessageLoad(
			{ message: 'Uy, algo no ha salido bien. Prueba cargando de nuevo la página.' },
			{
				contentId: `Error: Generic Error`,
			},
		);
		layerManager.openAlert(
			() => (
				<ThemeProvider theme={'inverted'}>
					<Container
						wrap={'always'}
						padding={ContainerPadding.dynamic0150}
						gutter={ContainerGutter.dynamic0050}
						horizontalAlign={'center'}
					>
						<Container
							wrap={'always'}
							gutter={ContainerGutter.dynamic0050}
							horizontalAlign={'center'}
							verticalAlign={'center'}
						>
							<Text appearance={TokenTextAppearance.headline400} textAlign={TextAlignment.center} bold>
								Uy, algo no ha salido bien
							</Text>
							<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
								Prueba cargando de nuevo la página.
							</Text>
						</Container>
						<Container padding={{ top: ContainerPadding.dynamic0100 }} horizontalAlign={'center'}>
							<Text color={TokenTextColor.primary} textAlign={TextAlignment.center} bold>
								<CTA tag="button" emphasis="primary" onClick={() => window.location.reload()} aria-label="closePopUp">
									<Text bold>Refrescar</Text>
								</CTA>
							</Text>
						</Container>
					</Container>
				</ThemeProvider>
			),
			{},
			{ shimBackgroundType: ShimBackgroundTypeV2.OPAQUE },
		);
	};

	return { showAlert };
};
